// Dependencies
import React from 'react';
import radium from 'radium';
import { connect } from 'react-redux';
import history from '../lib/history';
import Button from '../components/button/Button.tsx';
import ButtonEventsOverview from '../components/button-events-overview/ButtonEventsOverview.jsx';
import {ThemeContext} from "../components/theme/Theme.jsx";

function WebshopOccupiedInfoPage(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			margin: 'auto',
			display: 'flex',
			flexWrap: 'wrap',
			alignContent: 'center',
			paddingBottom: '5em',
		},
		error: {
			fontWeight: '600',
			textAlign: 'center',
			width: '100%',
		},
		buttonContainer: {
			marginTop: '3em',
		},
	};

	const eventSpecific = !!props.eventUuid;
	const text = context.themeManager.getThemeTextOrHardcodedDefault('webshopOccupiedText');

	function navigateToStartPage() {
		history.push(`${props.eventUuid}`);
	}

	return (
		<div style={style.container}>
			<div style={style.error} dangerouslySetInnerHTML={{ __html: text }} />
			{eventSpecific &&
				<Button
					name="to_startpage"
					buttonText="Zur Startseite"
					btnStyle="highlight"
					onClick={navigateToStartPage}
					buttonContainerStyle={style.buttonContainer}
				/>
			}
			{!eventSpecific &&
				<ButtonEventsOverview
					btnText={context.themeManager.getThemeTextOrHardcodedDefault('goToEventOverviewBtnLabel')}
					buttonContainerStyle={style.buttonContainer}
					iconName="angles-left"
				/>
			}
		</div>
	);
}

const mapStateToProps = (state) => {
	const event = state.event.elements[state.event.selected] || null;
	const eventUuid = event ? event.uuid : null;
	return {
		eventUuid,
	};
};
const RadiumWebshopOccupiedInfoPage = radium(WebshopOccupiedInfoPage);
export default connect(
	mapStateToProps,
)(RadiumWebshopOccupiedInfoPage);
